import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IBankfund24DataState } from "./bankfund24.types";
import { Bankfund24DataInitialState } from "./bankfund24.state";
import { FETCH_BANKFUND24_DATA_FAILURE, FETCH_BANKFUND24_DATA_PROGRESS, FETCH_BANKFUND24_DATA_SUCCESS, FETCH_SINGLE_BANKFUND24_DATA_FAILURE, FETCH_SINGLE_BANKFUND24_DATA_PROGRESS, FETCH_SINGLE_BANKFUND24_DATA_SUCCESS, CLEAR_BANKFUND24_DATA_STATE } from "./bankfund24.action";


export const bankfund24Reducer = (
    state: IBankfund24DataState = Bankfund24DataInitialState,
    action: any
) => {
    switch (action.type) {
        case FETCH_BANKFUND24_DATA_PROGRESS: {
            const newState = produce(state, (draftState: IBankfund24DataState) => {
                draftState.list.loading = LoadState.InProgress;
                draftState.list.data = [];
                draftState.list.totalRecords = 0;
            });
            return newState;
        }
        case FETCH_BANKFUND24_DATA_SUCCESS: {
            const { data, totalRecords } = action.payload;
            const newState = produce(state, (draftState: IBankfund24DataState) => {
                draftState.list.loading = LoadState.Loaded;
                draftState.list.data = data;
                draftState.list.totalRecords = totalRecords;
            });
            return newState;
        }
        case FETCH_BANKFUND24_DATA_FAILURE: {
            const newState = produce(state, (draftState: IBankfund24DataState) => {
                draftState.list.loading = LoadState.Failed;
                draftState.list.error = action.payload;
            });
            return newState;
        }
        case FETCH_SINGLE_BANKFUND24_DATA_PROGRESS: {
            const newState = produce(state, (draftState: IBankfund24DataState) => {
                draftState.bankfund24Data.loading = LoadState.InProgress;
            });
            return newState;
        }
        case FETCH_SINGLE_BANKFUND24_DATA_SUCCESS: {
            const newState = produce(state, (draftState: IBankfund24DataState) => {
                draftState.bankfund24Data.loading = LoadState.Loaded;
                draftState.bankfund24Data.data = action.payload;
            });
            return newState;
        }
        case FETCH_SINGLE_BANKFUND24_DATA_FAILURE: {
            const newState = produce(state, (draftState: IBankfund24DataState) => {
                draftState.bankfund24Data.loading = LoadState.Failed;
                draftState.bankfund24Data.error = action.payload;
            });
            return newState;
        }
        case CLEAR_BANKFUND24_DATA_STATE: {
            return Bankfund24DataInitialState;
        }
        default: {
            return state;
        }
    }
}; 